export * from './class-mapper';
export * from './components';
export * from './custom-components';
export * from './custom-hooks';
export * from './deck-hooks';
export * from './globals';
export * from './millennium-api';
export * from './modules';
export * from './constSysfsExpr';
export * from './utils';
export * from './webpack';
import ErrorBoundaryHook from './hooks/error-boundary-hook';
import RouterHook from './hooks/router/router-hook';
import Toaster from './hooks/toaster-hook';
export const errorBoundaryHook = new ErrorBoundaryHook();
export const routerHook = new RouterHook();
export const toaster = new Toaster();
export const definePlugin = (fn) => {
    return (...args) => {
        // TODO: Maybe wrap this
        return fn(...args);
    };
};
